export const hasMembers = (obj) => obj?.members?.length > 0;

export const getParamWithRequiredField = ({
  param,
  operationRequiredFields,
  shouldAddOptionalAnnotation = false,
}) => {
  const required = operationRequiredFields?.includes(param.name);
  /* If is auto velo docs we should override the optional fields that given by the message" */
  const optionalFieldOverride = shouldAddOptionalAnnotation
    ? { optional: !required }
    : {};

  const detailsOnRequired = operationRequiredFields
    ? {
        requiredFields: operationRequiredFields.filter(
          (field) => field.startsWith(param.name) && field !== param.name,
        ),
        required,
      }
    : {};

  return { ...param, ...detailsOnRequired, ...optionalFieldOverride };
};
